import { TooltipProps } from '../interface/interface';

export const Tooltip = ({ text, className, id }: TooltipProps) => (
  <div
    id={id}
    className={`${className} absolute bg-white shadow text-xs text-primary-blue-500 p-2 rounded top-8 w-max`}
  >
    {text}
  </div>
);
